/** Цвет метки: один и тот же для одного слова, точки различимы в обеих темах. */
const DOTS = ["bg-[#2f9e44]", "bg-[#2f80ed]", "bg-[#e8a317]", "bg-[#9b51e0]", "bg-[#e5484d]", "bg-[#12a594]"];

export function tagDot(tag: string): string {
  let h = 0;
  for (const ch of tag.toLowerCase()) h = (h * 31 + ch.codePointAt(0)!) >>> 0;
  return DOTS[h % DOTS.length]!;
}
